<div class="layout-container" [style.backgroundColor]="backgroundColor">
  <!-- start loading -->
  <div class="loading" *ngIf="showLoading">
    <app-spinner></app-spinner>
  </div>
  <!-- end loading -->

  <!-- start content -->
  <div class="content">
    <ng-content></ng-content>
  </div>
  <!-- end content -->
</div>
